import { Injectable } from '@angular/core';
import { DataService } from './core/data.service';
import { DocumentoPreEditado } from '../_models';

@Injectable({ providedIn: 'root' })
export class ProtocoloFiscalService extends DataService {
    context = 'fiscal';

    public salvarProtocolo(form: FormData) {
        return this.post<any>(null, form);
    }

    public atualizarProtocolo(form: FormData) {
        return this.put<any>(null, form);
    }

    public obterProtocolo(id: number) {
        return this.get<any>(`${id}`);
    }

    public cancelarProtocolo(idProtocolo: number) {
        return this.get<any>(`${idProtocolo}/cancelar`);
    }

    public excluirProtocolo(id: number) {
        return this.delete(null, id);
    }

    public VerificaProtocoloDuplicidade(idProtocolo: number, dtEmissao: string, cnpjFornecedor: string, nDocumento: string) {
        const apiUrl = 'duplicidade';

        const body = {
            idProtocolo: idProtocolo,
            dtEmissao: dtEmissao,
            cnpjFornecedor: cnpjFornecedor,
            nDocumento: nDocumento
        };

        return this.post<DocumentoPreEditado>(apiUrl, body);
    }

    public obterStatusELogProtocolo(idProtocolo: number) {
        return this.get<string>(`${idProtocolo}/status`);
    }

    AprovarProtocoloFiscal(formDataUpload: FormData){
        const apiURL = `aprovar`;
        return this.post<any>(apiURL, formDataUpload);
    }

    ObterCfop(cfop: number) {
        return this.get(`cfop/${cfop}`);
    }
}
